import React, { memo } from "react";
import styled from "styled-components";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";

const Holder = styled.div`
  width: 100%;
  height: ${({ height }) => (height ? height : "600px")};
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

function InfiniteList({
  isItemLoaded,
  loadMoreItems,
  height,
  itemCount,
  renderItem,
  itemSize = 50,
  listRef,
  minimumBatchSize = 20,
}) {
  return (
    <Holder height={height}>
      <InfiniteLoader
        ref={listRef}
        isItemLoaded={isItemLoaded}
        loadMoreItems={loadMoreItems}
        itemCount={itemCount}
        minimumBatchSize={minimumBatchSize}
      >
        {({ onItemsRendered, ref }) => (
          <AutoSizer>
            {({ width, height }) => (
              <FixedSizeList
                itemCount={itemCount}
                onItemsRendered={onItemsRendered}
                ref={ref}
                height={height}
                width={width}
                itemSize={itemSize}
                columnWidth={300}
                columnHeight={80}
                overscanCount={20}
              >
                {({ index, style }) => <div style={style}>{renderItem(index)}</div>}
              </FixedSizeList>
            )}
          </AutoSizer>
        )}
      </InfiniteLoader>
    </Holder>
  );
}

export default memo(InfiniteList);
